import api from "../index";
import { apiUrl } from "../../utils/constants";

export const GetPositions = (params) => api.get(apiUrl.positions, { params });
